import React, { useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import axios from "axios"

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  outline: "none",
  background: "#fff",
  marginBottom: 12
}

export default function AcceptInvitationPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const token = params.get("token") || ""

  const [name, setName] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")

      if (!token) {
        setError("Invitación inválida: falta el token.")
        return
      }

      if (!name.trim()) {
        setError("Escribe tu nombre.")
        return
      }

      if (!password) {
        setError("Escribe una contraseña.")
        return
      }

      if (password.length < 6) {
        setError("La contraseña debe tener al menos 6 caracteres.")
        return
      }

      if (password !== confirmPassword) {
        setError("Las contraseñas no coinciden.")
        return
      }

      setLoading(true)

      await axios.post("/api/invitations/accept", {
        token,
        name: name.trim(),
        password,
      })

      setSuccess(true)
    } catch (err) {
      const message =
        err?.response?.data?.message || "No se pudo aceptar la invitación."
      setError(Array.isArray(message) ? message[0] : message)
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#f8fafc",
          padding: 24
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 480,
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 16,
            padding: 24,
            boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)"
          }}
        >
          <h2 style={{ marginTop: 0 }}>Cuenta creada correctamente</h2>
          <p style={{ color: "#64748b", lineHeight: 1.5 }}>
            Tu invitación fue aceptada y tu usuario ya está listo.
          </p>

          <button
            onClick={() => navigate("/agenda")}
            style={{
              marginTop: 12,
              padding: "10px 14px",
              borderRadius: 10,
              border: "none",
              background: "#2563eb",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer"
            }}
          >
            Ir al sistema
          </button>
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f8fafc",
        padding: 24
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 480,
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)"
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 6 }}>Aceptar invitación</h2>
        <div style={{ color: "#64748b", marginBottom: 18 }}>
          Completa tus datos para activar tu acceso.
        </div>

        {error && (
          <div
            style={{
              background: "#fff1f0",
              border: "1px solid #ffa39e",
              color: "#a8071a",
              borderRadius: 10,
              padding: "10px 12px",
              marginBottom: 16,
              fontWeight: 600
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nombre completo"
            style={inputStyle}
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            style={inputStyle}
          />

          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirmar contraseña"
            style={inputStyle}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: 10,
              border: "none",
              background: loading ? "#cbd5e1" : "#2563eb",
              color: "#fff",
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "Creando cuenta..." : "Aceptar invitación"}
          </button>
        </form>
      </div>
    </div>
  )
}